
import { useState } from "react";
import RequestQuoteModal from "../../../components/feature/RequestQuoteModal";

export default function ComparisonSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Drafting vs Takeoff Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Understanding the difference helps you choose the right service for your project needs
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-orange-50 to-white p-8 lg:p-10 rounded-2xl border-2 border-orange-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-[#e18033] rounded-xl">
                <i className="ri-pencil-ruler-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900">Drafting Services</h3>
            </div>

            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              Creating detailed technical drawings and construction documents that communicate design intent and specifications.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#e18033] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Visual Documentation</strong>
                  <span className="text-sm text-gray-600">Floor plans, elevations, sections, and details</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#e18033] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Design Communication</strong>
                  <span className="text-sm text-gray-600">Conveys architectural and engineering intent</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#e18033] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Permit Submissions</strong>
                  <span className="text-sm text-gray-600">Required for building department approvals</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#e18033] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Construction Guidance</strong>
                  <span className="text-sm text-gray-600">Provides builders with detailed instructions</span>
                </div>
              </div>
            </div>

            <div className="bg-white p-4 rounded-lg">
              <strong className="text-gray-900 block mb-2">Best For:</strong>
              <p className="text-sm text-gray-600">
                New construction, renovations, permit applications, design development, and construction documentation
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-white p-8 lg:p-10 rounded-2xl border-2 border-orange-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-[#c97029] rounded-xl">
                <i className="ri-calculator-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900">Takeoff Services</h3>
            </div>

            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              Quantifying materials, labor, and costs from construction drawings to create accurate project estimates and budgets.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#c97029] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Quantity Calculations</strong>
                  <span className="text-sm text-gray-600">Precise measurements of all materials needed</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#c97029] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Cost Estimation</strong>
                  <span className="text-sm text-gray-600">Detailed pricing for materials, labor, and equipment</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#c97029] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Bid Preparation</strong>
                  <span className="text-sm text-gray-600">Accurate numbers for competitive project bidding</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#c97029] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Budget Management</strong>
                  <span className="text-sm text-gray-600">Helps control costs and prevent overruns</span>
                </div>
              </div>
            </div>

            <div className="bg-white p-4 rounded-lg">
              <strong className="text-gray-900 block mb-2">Best For:</strong>
              <p className="text-sm text-gray-600">
                Project bidding, budget planning, cost control, material ordering, and financial forecasting
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-gradient-to-r from-[#e18033] to-[#c97029] p-8 rounded-2xl text-center">
          <h3 className="text-2xl font-bold text-white mb-3">
            Need Both Services?
          </h3>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            Many projects benefit from combining drafting and takeoff services for complete documentation and accurate cost control from design through construction
          </p>
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-white text-gray-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Get Combined Quote
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>

      <RequestQuoteModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
}
